module.exports = __webpack_public_path__ + "img/UTFRON-3.5d7d37f7.jpg";